import * as React from 'react';

import type {TFunction} from 'i18next';

interface BooleanSelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  b: boolean;
  t: TFunction;
}

const BooleanSelect: React.FC<BooleanSelectProps> = props => {
  const {b, t, ...selectProps} = props;
  return (
    <select defaultValue={`${b}`} {...selectProps}>
      <option key="1" value="false" aria-selected={b === false}>
        {t('no')}
      </option>
      <option key="2" value="true" aria-selected={b === true}>
        {t('yes')}
      </option>
    </select>
  );
};

export default BooleanSelect;
